export default {
  pdfViewer: {
    ocorreuErro: 'Se produjo un error al cargar el archivo.',
    carregando: 'Cargando...'
  }
};
